import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { LinksService } from '../services/links.service';

@Pipe({
  name: 'linksToButtons',
  standalone: false
})
export class LinksToButtonsPipe implements PipeTransform {
  constructor(private domSanitizer: DomSanitizer) {}

  transform(text: string) {
    if (!text) {
      return;
    }

    const parser = new DOMParser();
    const htmlDoc = parser.parseFromString(text, 'text/html');

    const links = htmlDoc.getElementsByTagName('a');

    for (let i = 0; i < links.length; i++) {
      const element: HTMLAnchorElement = links[i];
      element.removeAttribute('onclick');
      element.removeAttribute('target');
      element.setAttribute('rel', 'noopener noreferrer');

      const currentClass = element.getAttribute('class') || '';
      if (!currentClass.split(' ').includes(LinksService.SYSTEM_LINK_CLASS)) {
        element.setAttribute('class', `${currentClass} ${LinksService.SYSTEM_LINK_CLASS}`.trim());
      }
    }

    const innerHTML = htmlDoc.getElementsByTagName('body')[0].innerHTML;

    return this.domSanitizer.bypassSecurityTrustHtml(innerHTML);
  }
}
